export default __webpack_public_path__ + "static/media/S.f98e839e.gif";